module.exports = __webpack_public_path__ + "static/media/5.e2a6b145.jpg";